<!-- FILE: src/views/ProfilePage.vue -->
<template>
  <div class="container my-5">
    <!-- رأس الصفحة -->
    <div v-if="user" class="d-flex align-items-center mb-4">
      <i class="bi bi-person-circle fs-1 text-primary me-3"></i>
      <div>
        <h2 class="mb-0">أهلاً بك، {{ user.name }}</h2>
        <p class="text-muted">هنا يمكنك الاطلاع على بياناتك وتحديث كلمة المرور.</p>
      </div>
    </div>
    <h2 v-else>صفحة المشترك الشخصية</h2>

    <!-- حالات التحميل والخطأ -->
    <div v-if="isLoading" class="text-center p-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">تحميل...</span>
      </div>
      <p class="mt-2">تحميل...</p>
    </div>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <!-- المحتوى الرئيسي بعد التحميل -->
    <div v-if="user">
      <!-- التبويبات -->
      <ul class="nav nav-tabs mb-4" id="profileTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="personal-info-tab" data-bs-toggle="tab" data-bs-target="#personal-info"
            type="button" role="tab" aria-controls="personal-info" aria-selected="true">
            <i class="bi bi-person-vcard-fill me-2"></i>بياناتي الشخصية
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="competition-info-tab" data-bs-toggle="tab" data-bs-target="#competition-info"
            type="button" role="tab" aria-controls="competition-info" aria-selected="false">
            <i class="bi bi-trophy-fill me-2"></i>بيانات المسابقة
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="change-password-tab" data-bs-toggle="tab" data-bs-target="#change-password"
            type="button" role="tab" aria-controls="change-password" aria-selected="false">
            <i class="bi bi-shield-lock-fill me-2"></i>تغيير كلمة المرور
          </button>
        </li>
      </ul>

      <!-- محتوى التبويبات -->
      <div class="tab-content" id="profileTabContent">
        <!-- تبويب البيانات الشخصية -->
        <div class="tab-pane fade show active" id="personal-info" role="tabpanel" aria-labelledby="personal-info-tab">
          <div class="card">
            <div class="card-header fs-5">
              تفاصيل البيانات
            </div>
            <ul class="list-group list-group-flush">
              <li class="list-group-item d-flex align-items-center">
                <i class="bi bi-person text-muted me-3 fs-5"></i>
                <strong>الاسم:</strong>
                <span class="mr-auto">{{ user.name }}</span>
              </li>
              <li class="list-group-item d-flex align-items-center">
                <i class="bi bi-card-text text-muted me-3 fs-5"></i>
                <strong>الرقم القومي:</strong>
                <span class="mr-auto">{{ user.national_id }}</span>
              </li>
              <li class="list-group-item d-flex align-items-center">
                <i class="bi bi-telephone text-muted me-3 fs-5"></i>
                <strong>الهاتف:</strong>
                <span class="ms-1">{{ user.phone }}</span>
              </li>
              <li class="list-group-item d-flex align-items-center">
                <i class="bi bi-geo-alt text-muted me-3 fs-5"></i>
                <strong>المدينة:</strong>
                <span class="mr-auto">{{ user.address_region }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- تبويب بيانات المسابقة والدرجات -->
        <div class="tab-pane fade" id="competition-info" role="tabpanel" aria-labelledby="competition-info-tab">
          <div class="row">
            <!-- بيانات المسابقة -->
            <div class="col-lg-6 mb-4">
              <div class="card h-100">
                <div class="card-header fs-5">بيانات اشتراك المسابقة</div>
                <ul class="list-group list-group-flush">
                  <li class="list-group-item"><strong>مستوى المسابقة:</strong> {{ levelNames[user.subscription_type] ||
                    'مستوى غير محدد' }}</li>
                  <li class="list-group-item"><strong>المرحلة الدراسية:</strong> {{ StageNames[user.education_stage] ||
                    'مرحلة غير محددة' }}</li>
                </ul>
              </div>
            </div>
            <!-- الدرجات -->
            <div class="col-lg-6 mb-4">
              <div class="card h-100">
                <div class="card-header fs-5">درجاتي في المسابقة</div>
                <div v-if="user.total_score !== null" class="card-body">
                  <p><strong>درجة الحفظ:</strong> {{ user.hifz_score }}</p>
                  <p><strong>درجة التجويد:</strong> {{ user.tajweed_score }}</p>
                  <p><strong>درجة الأداء:</strong> {{ user.performance_score }}</p>
                  <hr>
                  <div class="alert alert-success text-center">
                    <h4 class="alert-heading mb-0"><strong>المجموع الكلي:</strong> {{ user.total_score }}</h4>
                  </div>
                </div>
                <div v-else class="card-body text-center text-muted d-flex align-items-center justify-content-center">
                  <p class="mb-0"><i class="bi bi-hourglass-split me-2"></i>لم يتم رصد درجاتك بعد.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- تبويب تغيير كلمة المرور -->
        <div class="tab-pane fade" id="change-password" role="tabpanel" aria-labelledby="change-password-tab">
          <div class="card">
            <div class="card-header fs-5">تحديث كلمة المرور</div>
            <div class="card-body">
              <form @submit.prevent="changePassword">
             
                <div v-if="passwordChangeSuccess" class="alert alert-success">{{ passwordChangeSuccess }}</div>
                <div v-if="passwordChangeError" class="alert alert-danger">{{ passwordChangeError }}</div>

                <div class="mb-3">
                  <label for="current_password" class="form-label">كلمة المرور الحالية</label>
                  <input type="password" class="form-control" id="current_password"
                    v-model="passwordForm.current_password" required>
                </div>
                <div class="mb-3">
                  <label for="new_password" class="form-label">كلمة المرور الجديدة</label>
                  <input type="password" class="form-control" id="new_password" v-model="passwordForm.new_password"
                    required>
                </div>
                <div class="mb-3">
                  <label for="new_password_confirmation" class="form-label">تأكيد كلمة المرور الجديدة</label>
                  <input type="password" class="form-control" id="new_password_confirmation"
                    v-model="passwordForm.new_password_confirmation" required>
                </div>
                <button type="submit" class="btn btn-primary" :disabled="isChangingPassword">
                  <span v-if="isChangingPassword" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                  <span v-else>تغيير كلمة المرور</span>
                </button>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/axios';

export default {
  name: 'ProfilePage',
  data() {
    return {
      user: null,
      isLoading: true,
      error: null,
      levelNames: {
        level1: "المستوى الأول (القرآن كاملاً)",
        level2: "المستوى الثاني (نصف القرآن)",
        level3: "المستوى الثالث (10 أجزاء)",
        level4: "المستوى الرابع (5 أجزاء)"
      },
      StageNames: {
        g1: "المرحلة اﻻبتدائية ( عام )",
        g2: "المرحلة الاعدادية ( عام )",
        z1: "المرحلة اﻻبتدائية ( ازهر )",
        z2: "المرحلة اﻻعدادية ( ازهر )"
      },
      // بيانات نموذج تغيير كلمة المرور
      passwordForm: {
        current_password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      isChangingPassword: false,
      passwordChangeSuccess: null,
      passwordChangeError: null,
    }
  },
  async created() {
    try {
      const response = await api.get('/profile');
      this.user = response.data;
    } catch (err) {
      // يمكنك تخصيص رسالة الخطأ بناءً على الرد من الخادم
      if (err.response && err.response.status === 401) {
        this.error = "غير مصرح لك بالوصول. يرجى تسجيل الدخول مرة أخرى.";
      } else {
        this.error = "فشل في تحميل بيانات الملف الشخصي. يرجى المحاولة لاحقاً.";
      }
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async changePassword() {
      // إعادة تعيين الرسائل السابقة
      this.passwordChangeSuccess = null;
      this.passwordChangeError = null;

      // التحقق من تطابق كلمة المرور الجديدة
      if (this.passwordForm.new_password !== this.passwordForm.new_password_confirmation) {
        this.passwordChangeError = 'كلمة المرور الجديدة وتأكيدها غير متطابقين.';
        return;
      }

      this.isChangingPassword = true;

      try {
        // افترض أن لديك نقطة نهاية (endpoint) اسمها /change-password تقبل طلب POST
        const response = await api.post('/change-password', this.passwordForm);
        this.passwordChangeSuccess = response.data.message || 'تم تغيير كلمة المرور بنجاح!';

        // مسح الحقول بعد النجاح
        this.passwordForm.current_password = '';
        this.passwordForm.new_password = '';
        this.passwordForm.new_password_confirmation = '';

      } catch (err) {
        // عرض رسالة الخطأ القادمة من الخادم إذا كانت موجودة
        this.passwordChangeError = (err.response && err.response.data && err.response.data.message)
          ? err.response.data.message
          : 'حدث خطأ أثناء تغيير كلمة المرور. قد تكون كلمة المرور الحالية غير صحيحة.';
      } finally {
        this.isChangingPassword = false;
      }
    }
  }
}
</script>

<style scoped>
/* يمكنك إضافة بعض الأنماط المخصصة هنا إذا أردت */
.nav-link {
  color: #0d6efd;
}

.nav-link.active {
  color: #000;
  font-weight: bold;
}

.fs-1 {
  font-size: 4rem !important;
}
</style>